import { render, staticRenderFns } from "./BreadNav.vue?vue&type=template&id=b812069c&scoped=true&"
import script from "./BreadNav.vue?vue&type=script&lang=js&"
export * from "./BreadNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b812069c",
  null
  
)

export default component.exports